import { connect } from "react-redux";
import SEO from "@/components/SEO";
import { Link } from "react-router";
import { Link as MuiLink, Box, Typography } from "@mui/material";
import { withTranslation, WithTranslation } from "react-i18next";
import tokens from "@/theme/tokens";
import radii from "@/theme/radii";

interface NoMatchProps extends WithTranslation {
    userId?: number;
}

interface RootState {
    user: {
        get: (key: string) => any;
    };
}

const NoMatch = ({ userId, t }: NoMatchProps) => (
    <SEO title="404">
        <Box
            sx={{
                width: "100%",
                height: { xs: "calc(100vh - 60px)", sm: "calc(100vh - 65px)" },
                backgroundImage: 'url("/images/404_bg.png")',
                backgroundSize: "cover",
                backgroundPosition: "bottom left",
                backgroundRepeat: "no-repeat",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box
                sx={{
                    backgroundColor: tokens.color.noMatchScrim,
                    textAlign: "center",
                    margin: tokens.space.noMatchScrimMargin,
                    padding: tokens.space.px20,
                    borderRadius: `${radii.noMatchScrim}px`,
                }}
            >
                <Typography variant="h2" component="h2" align="center" gutterBottom>
                    {t("NoMatchTitle")}
                </Typography>
                <Typography variant="body1" sx={{ fontSize: tokens.fontSize.noMatchLostPhrase }}>
                    {t("LittleLostPhrase")}
                    <br />
                    {userId ? (
                        <span>
                            {t("Go")}{" "}
                            <MuiLink
                                underline="hover"
                                onClick={() => window.history.back()}
                            >
                                {t("back")}
                            </MuiLink>{" "}
                            {t("or")} {t("homeToYour")}{" "}
                            <MuiLink component={Link} to={`/profile/${userId}`} underline="hover">
                                {t("profile")}
                            </MuiLink>
                            .
                        </span>
                    ) : (
                        <span>
                            {t("Go")}{" "}
                            <MuiLink underline="hover"
                                onClick={() => window.history.back()}
                            >
                                {t("back")}
                            </MuiLink>{" "}
                            {t("or")}{" "}
                            <MuiLink component={Link} to="/" underline="hover">
                                {t("home")}
                            </MuiLink>
                            .
                        </span>
                    )}
                </Typography>
            </Box>
            <Box
                sx={{
                    marginTop: "15%",
                    marginLeft: "auto",
                    padding: tokens.space.px30,
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: { xs: tokens.fontSize.noMatchSubTextXs, sm: tokens.fontSize.noMatchSubTextSm },
                        marginBottom: tokens.space.px4,
                    }}
                >
                    &quot;{t("Explore")}&quot; {t("theySay")}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: { xs: tokens.fontSize.noMatchSubTextXs, sm: tokens.fontSize.noMatchSubTextSm },
                        marginBottom: tokens.space.px4,
                    }}
                >
                    &quot;{t("ItWillBeFun")}&quot; {t("theySay")}
                </Typography>
            </Box>
        </Box>
    </SEO>
);

function mapStateToProps(state: RootState) {
    const { user } = state;
    const userId = user.get("id");
    return {
        userId,
    };
}

export default withTranslation(["translation.utils"])(
    connect(mapStateToProps)(NoMatch)
);
